import { EmployeeLevelEnum, RoleName } from '../../types'

export const PARTNER_LEVELS: EmployeeLevelEnum[] = [
  EmployeeLevelEnum.P,
  EmployeeLevelEnum.Ep,
  EmployeeLevelEnum.Sp,
  EmployeeLevelEnum.Ap,
  EmployeeLevelEnum.Co,
]

export const MANAGER_ROLES: RoleName[] = [RoleName.CompanyManager, RoleName.NetworkManager, RoleName.ClusterManager]
